import { treezGreen, treezGrey, treezTextColors, treezSystemColors, treezSecondaryColors, treezBlackAndWhiteColors, } from "./treez-color-constants";
export const lightPalettePrimary = {
    primary: {
        main: treezGreen[5],
        dark: treezGreen[6],
        light: treezGreen[4],
        contrastText: treezTextColors.primary,
    },
    secondary: {
        main: treezTextColors.primary,
        contrastText: treezBlackAndWhiteColors.primaryWhite,
    },
    background: {
        default: treezGrey[1],
        secondary: treezGrey[8],
        disabled: treezTextColors.disabled,
    },
    text: {
        primary: treezTextColors.primary,
    },
    divider: treezGrey[4],
    info: {
        main: treezSystemColors.info.main,
        light: treezSystemColors.info.light,
        dark: treezSystemColors.info.dark,
    },
    success: {
        main: treezSystemColors.success.main,
        light: treezSystemColors.success.light,
        dark: treezSystemColors.success.dark,
    },
    warning: {
        main: treezSystemColors.warning.main,
        light: treezSystemColors.warning.light,
        dark: treezSystemColors.warning.dark,
    },
    error: {
        main: treezSystemColors.error.main,
        light: treezSystemColors.error.light,
        dark: treezSystemColors.error.dark,
    },
};
export const lightPaletteSecondary = {
    secondaryGreen: {
        main: treezGreen[4],
        dark: treezGreen[5],
        contrastText: treezTextColors.primary,
    },
    brown: {
        main: treezSecondaryColors.brown,
        dark: treezSecondaryColors.brownDark,
        contrastText: treezTextColors.primary,
    },
    orange: {
        main: treezSecondaryColors.orange,
        dark: treezSecondaryColors.orangeDark,
        contrastText: treezTextColors.primary,
    },
    peach: {
        main: treezSecondaryColors.peach,
        dark: treezSecondaryColors.peachDark,
        contrastText: treezTextColors.primary,
    },
    blue: {
        main: treezSecondaryColors.blue,
        dark: treezSecondaryColors.blueDark,
        contrastText: treezTextColors.primary,
    },
    purple: {
        main: treezSecondaryColors.purple,
        dark: treezSecondaryColors.purpleDark,
        contrastText: treezTextColors.primary,
    },
    yellow: {
        main: treezSecondaryColors.yellow,
        dark: treezSecondaryColors.yellowDark,
        contrastText: treezTextColors.primary,
    },
    // note spelling uses "a" not "e" --> "grey" is a reserved MUI color with a different type than a palette color--see MUI color palette types
    gray: {
        main: treezGrey[3],
        dark: treezGrey[4],
        contrastText: treezTextColors.primary,
    },
};
export const lightPalette = Object.assign(Object.assign({}, lightPalettePrimary), lightPaletteSecondary);
